export default "__VITE_ASSET__e9f2b263__"